(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('intrumento-relacionado', {
            parent: 'entity',
            url: '/intrumento-relacionado?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.intrumentoRelacionado.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionados.html',
                    controller: 'IntrumentoRelacionadoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intrumentoRelacionado');
                    $translatePartialLoader.addPart('tipoRelacionInstrumento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('intrumento-relacionado-detail', {
            parent: 'intrumento-relacionado',
            url: '/intrumento-relacionado/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.intrumentoRelacionado.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-detail.html',
                    controller: 'IntrumentoRelacionadoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intrumentoRelacionado');
                    $translatePartialLoader.addPart('tipoRelacionInstrumento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'IntrumentoRelacionado', function($stateParams, IntrumentoRelacionado) {
                    return IntrumentoRelacionado.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'intrumento-relacionado',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('intrumento-relacionado-detail.edit', {
            parent: 'intrumento-relacionado-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-dialog.html',
                    controller: 'IntrumentoRelacionadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IntrumentoRelacionado', function(IntrumentoRelacionado) {
                            return IntrumentoRelacionado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('intrumento-relacionado.new', {
            parent: 'intrumento-relacionado',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-dialog.html',
                    controller: 'IntrumentoRelacionadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                denominacion: null,
                                tipo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('intrumento-relacionado', null, { reload: 'intrumento-relacionado' });
                }, function() {
                    $state.go('intrumento-relacionado');
                });
            }]
        })
        .state('intrumento-relacionado.edit', {
            parent: 'intrumento-relacionado',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-dialog.html',
                    controller: 'IntrumentoRelacionadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IntrumentoRelacionado', function(IntrumentoRelacionado) {
                            return IntrumentoRelacionado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('intrumento-relacionado', null, { reload: 'intrumento-relacionado' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('intrumento-relacionado.delete', {
            parent: 'intrumento-relacionado',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-delete-dialog.html',
                    controller: 'IntrumentoRelacionadoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IntrumentoRelacionado', function(IntrumentoRelacionado) {
                            return IntrumentoRelacionado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('intrumento-relacionado', null, { reload: 'intrumento-relacionado' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
